import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BookOpen } from "lucide-react";
import api from "@/lib/api";
import { PageHeader, EmptyState, Badge } from "@/components/common";
import { Button } from "@/components/ui/button";
import { CertificateButton, ProgressBar } from "@/components/CertificateButton";

export default function MyCourses() {
  const [enrollments, setEnrollments] = useState([]);
  useEffect(() => { api.get("/my/enrollments").then(({ data }) => setEnrollments(data)); }, []);

  return (
    <div data-testid="my-courses-page">
      <PageHeader title="My Courses" subtitle={`${enrollments.length} enrolled`} />
      {enrollments.length === 0 ? (
        <EmptyState icon={BookOpen} title="No enrolled courses" action={<Link to="/courses"><Button className="viriks-navy text-white">Browse Courses</Button></Link>} />
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {enrollments.map((e) => (
            <div key={e.id} className="bg-white border border-border rounded-xl overflow-hidden" data-testid={`enrollment-${e.course_id}`}>
              {e.course.thumbnail ? <img src={e.course.thumbnail} alt="" className="w-full aspect-video object-cover" /> : <div className="w-full aspect-video bg-muted" />}
              <div className="p-4 space-y-3">
                <h3 className="font-semibold text-navy line-clamp-2 text-sm">{e.course.title}</h3>
                <div>
                  <ProgressBar value={e.progress || 0} testid={`progress-${e.course_id}`} />
                  <p className="text-xs text-muted-foreground mt-1">{e.completed_lessons?.length || 0} of {e.total_lessons || 0} lessons completed</p>
                </div>
                <div className="flex items-center justify-between gap-2">
                  <Badge tone={e.expired ? "crimson" : "green"}>{e.expired ? "Expired" : "Active"}</Badge>
                  <div className="flex gap-2">
                    {e.certificate && <CertificateButton cert={e.certificate} testid={`certificate-${e.course_id}`} />}
                    {e.expired ? (
                      <Link to={`/courses/${e.course_id}`}><Button size="sm" variant="outline">Renew</Button></Link>
                    ) : (
                      <Link to={`/learner/learn/${e.course_id}`}><Button size="sm" className="viriks-navy text-white" data-testid={`continue-${e.course_id}`}>{e.progress ? "Continue" : "Start"}</Button></Link>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
